<template>
    <div v-if="isMounted && items" ref="selector" class="slider-shell" >
        <!-- SLIDER -->
        <div id="sliderObject" class="slider-object slider-stage" >
            <!-- <div style="text-align: center; margin-top: -11px; white-space: nowrap; overflow: hidden; padding-left: 40px; margin-right: 50px;">
                <span style="font-size: 24px; color: #9198aa" :style="[item.id == currentItem.id ? {color: '#1997c6', 'text-shadow': '0px 0px 2px'}: '']" class="icon icon-dot-single" v-for="(item) in items" :key="item.id"></span>
            </div> -->
            <div class="slider-showcase">
                <carousel-3d
                class="slider-carousel"
                :startIndex="getStartIndex()"
                :controls-prev-html="'&#10092;'" :controls-next-html="'&#10093;'"
                :clickable="true"
                ref="slider"
                :key="carouselKey"
                :width="carouselWidth"
                :height="carouselHeight"
                :space="carouselSpace"
                :inverseScaling="carouselInverseScaling"
                :perspective="carouselPerspective"
                :display="3">
                    <slide
                        :key="item.id" v-for="(item, indxx) in items"
                        ref="slides"
                        class="slide slider-stage-card"
                        :class="{'ischosen': item.chosen, 'notchosen': !item.chosen || item.chosen == false || item.chosen == 'false'}"
                        :index="indxx"
                        >
                        <div class="slider-product-image" :style='[{backgroundImage: "url(" + getMainImgUrl(item.imgUrl) + ")"}]'></div>
                        <button v-if="item.chosen" type="button" :class="{'show-enlarge': item.chosen}" class="enlarge slider-enlarge-button" aria-label="View full-size product image" @click.stop="enlarge(item)">
                            <svg class="slider-enlarge-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M9 4H4v5M15 4h5v5M20 15v5h-5M4 15v5h5" />
                            </svg>
                        </button>
                        <div class="selector">
                            <div v-if="!item.chosen" class="banner-click">
                                <div class="banner-click-bg"></div>
                            </div>
                        </div>
                    </slide>
                </carousel-3d>
            </div>
                    <!-- DESCRIPTION -->
            <div v-if="this.currentItem.chosen==true" class="short-descr slider-summary-card">
                <div class="slider-summary-heading">
                    <div>
                        <div class="slider-summary-kicker">{{ currentTypeLabel }}</div>
                        <h2 class="big-title">{{ currentItemTitle }}</h2>
                    </div>
                </div>

                <div class="descr slider-summary-specs">
                    <div class="best-for" v-for="(compat, key, index) in getListBullets(currentItem)" :key="index">
                        <span class="small-bullet value">{{ summaryNumber(compat, key) }}<span v-if="summaryUnit(key)" class="chip-unit"> {{ summaryUnit(key) }}</span></span>
                        <span class="small-bullet key">{{key}} </span>
                    </div>
                    <div v-if="editorialOverviewLoading" class="slider-editorial-summary slider-editorial-summary--loading" role="status" aria-live="polite">
                        <div class="slider-editorial-heading">
                            <span>Loading GixCore editorial overview</span>
                        </div>
                        <div class="slider-editorial-skeleton" aria-hidden="true">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <span class="sr-only">Loading editorial overview for {{ currentItemTitle }}</span>
                    </div>
                    <div v-else-if="editorialOverviewParagraphs.length" class="slider-editorial-summary">
                        <div class="slider-editorial-heading">
                            <span>{{ editorialOverview ? 'GixCore editorial overview' : 'GixCore summary' }}</span>
                        </div>
                        <div
                            class="slider-editorial-copy"
                            :class="{ 'slider-editorial-copy--expanded': editorialOverviewExpanded || !editorialOverviewCanExpand }"
                        >
                            <p v-for="(paragraph, index) in editorialOverviewParagraphs" :key="index">
                                <span>{{ paragraph.text }}</span>
                                <span v-if="paragraph.sources.length" class="slider-editorial-sources" aria-label="Sources">
                                    <a
                                        v-for="source in paragraph.sources"
                                        :key="source.url"
                                        class="slider-editorial-source"
                                        :href="source.url"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        :aria-label="'Source: ' + source.label + ' (opens in a new tab)'"
                                        @click.stop
                                    >
                                        <span>{{ source.label }}</span>
                                        <span class="slider-editorial-source-arrow" aria-hidden="true">&nearr;</span>
                                    </a>
                                </span>
                            </p>
                        </div>
                        <button
                            v-if="editorialOverviewCanExpand"
                            type="button"
                            class="slider-editorial-toggle"
                            :aria-expanded="editorialOverviewExpanded ? 'true' : 'false'"
                            @click="editorialOverviewExpanded = !editorialOverviewExpanded"
                        >
                            {{ editorialOverviewExpanded ? 'Show less' : 'Read full overview' }}
                            <span aria-hidden="true">{{ editorialOverviewExpanded ? '↑' : '↓' }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- SPEEDOMETER & COMPAT TABLE -->
        <div class="speedometer-div slider-side-panel">
            <div class="slider-panel-card slider-performance-panel">
                <div class="slider-panel-header">
                    <div class="slider-panel-label">
                        <span>{{ hasPerformanceGauge ? 'Performance and fit' : 'Compatibility snapshot' }}</span>
                    </div>
                    <span v-if="hasPerformanceGauge" class="slider-score-pill" :class="performanceScoreToneClass">{{ performanceScore }}/100</span>
                </div>
                <p v-if="hasPerformanceGauge" class="slider-panel-note">{{ performanceSummary }}</p>
            <!-- SPEEDOMETER -->
            <div v-if="this.currentItem.chosen==true && hasPerformanceGauge" class="slider-meter-shell">
                <vue-speedometer class="speedometer"
                    :height="128"
                    :width="196"
                    :needleHeightRatio="0.6"
                    valueTextFontSize="16px"
                    :value="perf < 100 ? perf : 100"
                    :maxValue="101"
                    :segments="3"
                    currentValueText="Performance "
                    :segmentColors='["#c7254e", "#e1d420", "#18b37e" ]'
                    :ringWidth="4"
                    :needleTransitionDuration="1000"
                    needleTransition="easeQuadInOut"
                    needleColor="#cfd2da"
                    textColor="#1997c6"
                    :fontWeight="'600'"
                    :customSegmentLabels='[
                        {
                            text: "Slow",
                            position: "OUTSIDE",
                            color: "#9198aa",
                        },
                        {
                            text: " ",
                            position: "OUTSIDE",
                            color: "#9198aa",
                        },
                        {
                            text: "Fast",
                            position: "OUTSIDE",
                            color: "#9198aa",
                        },
                    ]'
                />
            </div>
            <div v-else-if="this.currentItem.chosen==true" class="slider-compat-brief" :class="'slider-compat-brief--' + compatSummary.kind">
                <span class="icon" :class="compatSummary.icon"></span>
                <span>{{ compatSummary.label }}</span>
            </div>
            <!-- COMPATS -->
            <div v-if="this.currentItem.chosen==true" class="infographics">
        <!-- CPU INFO -->
                <!-- FREQUENCY -->
                <div style="min-width: 87px !important" v-if="this.currentItem.chosen==true && this.currentItem.type == 'cpu'" class="best-for" >
                    <span style="display:block; min-width: 80px;" class="small-bullet value">{{parseFloat(this.currentItem.specs.Core_Frequency)}}<span class="chip-unit"> GHz</span></span>
                    <span class="small-bullet key">Frequency</span>
                </div>
                <!-- CORES -->
                <div style="min-width: 68px !important" v-if="this.currentItem.chosen==true && this.currentItem.type == 'cpu'" class="best-for" >
                    <span style=" display:block; " class="small-bullet value">{{this.currentItem.specs.Number_of_Cores}}</span>
                    <span class="small-bullet key">Cores</span>
                </div>
                <!-- THREADS -->
                <div style="min-width: 68px !important" v-if="this.currentItem.chosen==true && this.currentItem.type == 'cpu'" class="best-for" >
                    <span style=" display:block;" class="small-bullet value">{{this.currentItem.specs.Number_of_Threads}}</span>
                    <span class="small-bullet key">Threads</span>
                </div>
                <!-- SOCKET -->
                <div style="" v-if="this.currentItem.chosen==true && this.currentItem.type == 'cpu'" class="best-for" >
                    <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents" class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'socket'})}}</div>
                    <span style="display:block;"
                    :class="{
                        incompatible: checkCompatTable('motherboard', 'socket', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: checkCompatTable('motherboard', 'socket', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"
                    class="small-bullet value">{{this.currentItem.compat.socket}}</span>
                    <span v-if="compatIssueMsg([['motherboard','socket']])" class="icon compat-issue-badge" :class="compatIssueIcon([['motherboard','socket']])" v-gixtip="compatIssueMsg([['motherboard','socket']])"></span>
                    <span class="small-bullet key">Socket</span>
                </div>
                <!-- MAX RAM -->
                <div style="" v-if="this.currentItem.chosen==true && this.currentItem.type == 'cpu'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'max_memory'})}}</div>
                    <span :class="{
                        incompatible:
                                checkCompatTable('ram', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:
                                checkCompatTable('ram', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"
                    style="display:block;"
                    class="small-bullet value">
                        {{allMenuOptions.ram.item.contents ? parseInt(getItemValue({item: allMenuOptions.ram.item.contents, field: 'capacity'}))+'/':""}}{{parseInt(this.currentItem.specs.Max_Memory_Size)}}<span class="chip-unit"> GB</span>
                    </span>
                    <span v-if="compatIssueMsg([['ram','max_memory']])" class="icon compat-issue-badge" :class="compatIssueIcon([['ram','max_memory']])" v-gixtip="compatIssueMsg([['ram','max_memory']])"></span>
                    <span class="small-bullet key">Max Memory</span>
                </div>
                <!-- MEMORY SPEED -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'cpu')" class="best-for" >
                    <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'ram_speed'})}}</div>
                    <div v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'ram_speed'})}}</div>
                    <span
                     :class="{
                        incompatible: checkCompatTable('motherboard', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == false || checkCompatTable('ram', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == true || checkCompatTable('ram', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"
                     style=" display:block;"
                     class="small-bullet value">{{parseInt(this.currentItem.compat.ram_speed)}}<span class="chip-unit"> MHz</span></span>
                    <span v-if="compatIssueMsg([['motherboard','ram_speed'],['ram','ram_speed']])" class="icon compat-issue-badge" :class="compatIssueIcon([['motherboard','ram_speed'],['ram','ram_speed']])" v-gixtip="compatIssueMsg([['motherboard','ram_speed'],['ram','ram_speed']])"></span>
                    <span class="small-bullet key">Memory Speed</span>
                </div>
                <!-- MEMORY TYPE-->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'cpu'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'ram_type'})}}</div>
                    <div  v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'ram_type'})}}</div>
                    <span
                    :class="{
                        incompatible:
                            checkCompatTable('motherboard', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('ram', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:
                            checkCompatTable('motherboard', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('ram', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"
                    style=" display:block;"
                    class="small-bullet value">{{this.currentItem.compat.ram}}</span>
                    <span v-if="compatIssueMsg([['motherboard','ram_type'],['ram','ram_type']])" class="icon compat-issue-badge" :class="compatIssueIcon([['motherboard','ram_type'],['ram','ram_type']])" v-gixtip="compatIssueMsg([['motherboard','ram_type'],['ram','ram_type']])"></span>
                    <span class="small-bullet key">Memory Type</span>
                </div>
        <!-- MB INFO -->
                <h4 v-if="this.currentItem.chosen==true && this.currentItem.type !== 'cpu' && this.currentItem.type !== 'graphics' && this.currentItem.type !== 'gpu'" class="slider-compat-heading">Compatibility</h4>
                <!-- SOCKET -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'motherboard'" class="best-for" >
                    <div v-if="allMenuOptions && allMenuOptions.cpu.item.contents" class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'socket'})}}</div>
                    <span
                    :class="{
                        incompatible: checkCompatTable('cpu', 'socket', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: checkCompatTable('cpu', 'socket', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"
                     style=" display:block;"
                     class="small-bullet value">{{this.currentItem.specs.Socket}}</span>
                    <span v-if="compatIssueMsg([['cpu','socket']])" class="icon compat-issue-badge" :class="compatIssueIcon([['cpu','socket']])" v-gixtip="compatIssueMsg([['cpu','socket']])"></span>
                    <span class="small-bullet key">Socket</span>
                </div>
                <!-- MEMORY TYPE-->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'motherboard'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.cpu.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'ram_type'})}}</div>
                    <div  v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'ram_type'})}}</div>
                    <span
                    :class="{
                        incompatible:
                            checkCompatTable('cpu', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('ram', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:
                            checkCompatTable('cpu', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('ram', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"
                    style=" display:block;"
                    class="small-bullet value">{{this.currentItem.compat.ram}}</span>
                    <span v-if="compatIssueMsg([['cpu','ram_type'],['ram','ram_type']])" class="icon compat-issue-badge" :class="compatIssueIcon([['cpu','ram_type'],['ram','ram_type']])" v-gixtip="compatIssueMsg([['cpu','ram_type'],['ram','ram_type']])"></span>
                    <span class="small-bullet key">Memory Type</span>
                </div>
                <!-- MEMORY SPEED -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'motherboard')" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.cpu.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'ram_speed'})}}</div>
                    <div  v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'ram_speed'})}}</div>
                    <span
                     :class="{
                        incompatible:
                            checkCompatTable('cpu', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:
                            checkCompatTable('cpu', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('ram', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"
                     style=" display:block;"
                     class="small-bullet value">{{parseInt(this.currentItem.compat.ram_speed)}}<span class="chip-unit"> MHz</span></span>
                    <span v-if="compatIssueMsg([['cpu','ram_speed'],['ram','ram_speed']])" class="icon compat-issue-badge" :class="compatIssueIcon([['cpu','ram_speed'],['ram','ram_speed']])" v-gixtip="compatIssueMsg([['cpu','ram_speed'],['ram','ram_speed']])"></span>
                    <span class="small-bullet key">Memory Speed</span>
                </div>
                <!-- MEMORY SLOTS -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'motherboard'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'number_of_items'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('ram', 'number_of_items', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('ram', 'number_of_items', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"
                    style=" display:block;"
                    class="small-bullet value"><span v-if="allMenuOptions && allMenuOptions.ram.item.contents">{{parseInt(getItemValue({item: allMenuOptions.ram.item.contents, field: 'slots'})) }}/</span><span >{{this.currentItem.compat.ram_slots}}</span></span>
                    <span v-if="compatIssueMsg([['ram','number_of_items']])" class="icon compat-issue-badge" :class="compatIssueIcon([['ram','number_of_items']])" v-gixtip="compatIssueMsg([['ram','number_of_items']])"></span>
                    <span class="small-bullet key">Memory Slots</span>
                </div>
                <!-- MAX MEMORY -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'motherboard'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'max_memory'})}}</div>
                    <span :class="{
                        incompatible:
                            checkCompatTable('cpu', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('ram', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:
                            checkCompatTable('cpu', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('ram', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"
                    style=" display:block;"
                    class="small-bullet value">
                        {{allMenuOptions.ram.item.contents ? parseInt(getItemValue({item: allMenuOptions.ram.item.contents, field: 'capacity'}))+'/':""}}{{parseInt(this.currentItem.specs.Max_Memory_Size)}}<span class="chip-unit"> GB</span>
                    </span>
                    <span v-if="compatIssueMsg([['cpu','max_memory'],['ram','max_memory']])" class="icon compat-issue-badge" :class="compatIssueIcon([['cpu','max_memory'],['ram','max_memory']])" v-gixtip="compatIssueMsg([['cpu','max_memory'],['ram','max_memory']])"></span>
                    <span class="small-bullet key">Max Memory</span>
                </div>
                <!-- PROCESSOR GENERATION -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'motherboard'" class="best-for" >
                     <div  v-if="allMenuOptions && allMenuOptions.cpu.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'processor_generation'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('cpu', 'processor_generation', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('cpu', 'processor_generation', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"
                    style=" display:block;"
                    class="small-bullet value">
                        {{parseInt(this.currentItem.compat.processor_generation)}}
                    </span>
                    <span v-if="compatIssueMsg([['cpu','processor_generation']])" class="icon compat-issue-badge" :class="compatIssueIcon([['cpu','processor_generation']])" v-gixtip="compatIssueMsg([['cpu','processor_generation']])"></span>
                    <span class="small-bullet key">Processor Gen</span>
                </div>
                <!-- PCI-E -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'motherboard'" class="best-for" >
                    <span style=" display:block;" class="small-bullet value">{{this.currentItem.compat.pci_e}}</span>
                    <span class="small-bullet key">PCI-Express</span>
                </div>
                <!-- FORM FACTOR -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'motherboard')" class="best-for" >
                    <div v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'psu', option: 'form_factor'})}}</div>
                    <div v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'case', option: 'form_factor'})}}</div>
                    <span :class="{
                        incompatible:
                            checkCompatTable('psu',  'form_factor', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('case', 'form_factor', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:
                            checkCompatTable('psu',  'form_factor', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('case', 'form_factor', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"
                    style=" display:block;"
                    class="small-bullet value">
                        <span v-if="allMenuOptions">{{this.currentItem.compat.form_factor}}</span>
                    </span>
                    <span v-if="compatIssueMsg([['psu','form_factor'],['case','form_factor']])" class="icon compat-issue-badge" :class="compatIssueIcon([['psu','form_factor'],['case','form_factor']])" v-gixtip="compatIssueMsg([['psu','form_factor'],['case','form_factor']])"></span>
                    <span class="small-bullet key">Form Factor</span>
                </div>
        <!-- RAM -->
                <!-- MEMORY TYPE -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'ram'" class="best-for" >
                     <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'ram_type'})}}</div>
                     <div  v-if="allMenuOptions && allMenuOptions.cpu.item.contents" class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'ram_type'})}}</div>
                    <span
                    :class="{
                        incompatible:
                            checkCompatTable('cpu',         'ram_type', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('motherboard', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:
                            checkCompatTable('cpu',         'ram_type', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('motherboard', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"
                    style=" display:block;"
                    class="small-bullet value">{{this.currentItem.compat.ram_type}}</span>
                    <span v-if="compatIssueMsg([['cpu','ram_type'],['motherboard','ram_type']])" class="icon compat-issue-badge" :class="compatIssueIcon([['cpu','ram_type'],['motherboard','ram_type']])" v-gixtip="compatIssueMsg([['cpu','ram_type'],['motherboard','ram_type']])"></span>
                    <span class="small-bullet key">Memory Type</span>
                </div>
                <!-- MEMORY SPEED -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'ram')" class="best-for" >
                    <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'ram_speed'})}}</div>
                    <div v-if="allMenuOptions && allMenuOptions.cpu.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'ram_speed'})}}</div>
                    <span
                     :class="{
                        incompatible: checkCompatTable('motherboard', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == false || checkCompatTable('cpu', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == true || checkCompatTable('cpu', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"
                     style=" display:block;"
                     class="small-bullet value">{{parseInt(this.currentItem.compat.ram_speed)}}<span class="chip-unit"> MHz</span></span>
                    <span v-if="compatIssueMsg([['motherboard','ram_speed'],['cpu','ram_speed']])" class="icon compat-issue-badge" :class="compatIssueIcon([['motherboard','ram_speed'],['cpu','ram_speed']])" v-gixtip="compatIssueMsg([['motherboard','ram_speed'],['cpu','ram_speed']])"></span>
                    <span class="small-bullet key">Memory Speed</span>
                </div>
                <!-- MEMORY SLOTS -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'ram'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'ram_slots'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('motherboard', 'ram_slots', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'ram_slots', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"
                    style=" display:block;"
                    class="small-bullet value"><span>{{getItemValue({item: allMenuOptions.ram.item.contents, field: 'slots'}) || 0}}</span><span v-if="allMenuOptions && allMenuOptions.motherboard.item.contents">/{{parseInt(allMenuOptions.motherboard.item.contents.compat.ram_slots) }}</span></span>
                    <span v-if="compatIssueMsg([['motherboard','ram_slots']])" class="icon compat-issue-badge" :class="compatIssueIcon([['motherboard','ram_slots']])" v-gixtip="compatIssueMsg([['motherboard','ram_slots']])"></span>
                    <span class="small-bullet key">Memory Slots</span>
                </div>
                <!-- MAX-MEMORY -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'ram'" class="best-for" >
                     <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'max_memory'})}}</div>
                     <div  v-if="allMenuOptions && allMenuOptions.cpu.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'max_memory'})}}</div>
                    <span :class="{
                        incompatible:
                            checkCompatTable('cpu',         'max_memory', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('motherboard', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:
                            checkCompatTable('cpu',         'max_memory', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('motherboard', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"
                    style=" display:block;"
                    class="small-bullet value">
                        {{this.currentItem.compat.copacity + allMenuOptions.ram.item.contents ? parseInt(getItemValue({item: allMenuOptions.ram.item.contents, field: 'capacity'})):0}}<span v-if="(!allMenuOptions.motherboard.item.contents && !allMenuOptions.cpu.item.contents)" class="chip-unit"> GB</span><span v-if="allMenuOptions.motherboard.item.contents || allMenuOptions.cpu.item.contents">/{{parseInt(getMaxMem({cpu: allMenuOptions.cpu.item.contents, mb: allMenuOptions.motherboard.item.contents}))}}<span class="chip-unit"> GB</span></span>
                    </span>
                    <span v-if="compatIssueMsg([['cpu','max_memory'],['motherboard','max_memory']])" class="icon compat-issue-badge" :class="compatIssueIcon([['cpu','max_memory'],['motherboard','max_memory']])" v-gixtip="compatIssueMsg([['cpu','max_memory'],['motherboard','max_memory']])"></span>
                    <span class="small-bullet key">Total Memory</span>
                </div>
        <!-- STORAGE -->
                <!-- Interface -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'storage'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'interface'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('motherboard', 'interface', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'interface', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"
                    style=" display:block;"
                    class="small-bullet value">{{this.currentItem.compat.compat_interface}}</span>
                    <span v-if="compatIssueMsg([['motherboard','interface']])" class="icon compat-issue-badge" :class="compatIssueIcon([['motherboard','interface']])" v-gixtip="compatIssueMsg([['motherboard','interface']])"></span>
                    <span class="small-bullet key">Interface</span>
                </div>
                <!-- SLOTS -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'storage' && (allMenuOptions.storage.item.contents && isSataStorage(currentItem) && allMenuOptions.storage.item.contents.length >0 && allMenuOptions.motherboard.item.contents)" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'sata_slots'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('motherboard', 'sata_slots', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'sata_slots', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"
                    style=" display:block;"
                    class="small-bullet value"><span>{{countStorageBySlot(allMenuOptions.storage.item.contents, 'sata')}}</span>/{{parseInt(allMenuOptions.motherboard.item.contents.compat.sata_slots)}}</span>
                    <span v-if="compatIssueMsg([['motherboard','sata_slots']])" class="icon compat-issue-badge" :class="compatIssueIcon([['motherboard','sata_slots']])" v-gixtip="compatIssueMsg([['motherboard','sata_slots']])"></span>
                    <span class="small-bullet key">Sata Slots</span>
                </div>
                <!-- M.2 -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'storage' && (allMenuOptions.storage.item.contents && isM2Storage(currentItem) && allMenuOptions.storage.item.contents.length >0 && allMenuOptions.motherboard.item.contents)" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'm.2_slots'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('motherboard', 'm.2_slots', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'm.2_slots', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"
                    style=" display:block;"
                    class="small-bullet value"><span>{{countStorageBySlot(allMenuOptions.storage.item.contents, 'm2')}}</span>/{{parseInt(allMenuOptions.motherboard.item.contents.compat.M_2_Slot)}}</span>
                    <span v-if="compatIssueMsg([['motherboard','m.2_slots']])" class="icon compat-issue-badge" :class="compatIssueIcon([['motherboard','m.2_slots']])" v-gixtip="compatIssueMsg([['motherboard','m.2_slots']])"></span>
                    <span class="small-bullet key">M.2 Slots</span>
                </div>
        <!-- GRAPHICS -->
                <!-- Core Clock -->
                <div style="min-width: 85px !important" v-if="this.currentItem.chosen==true && this.currentItem.type == 'graphics'" class="best-for" >
                    <span style=" display:block; min-width: 80px;" class="small-bullet value">{{parseInt(this.currentItem.specs.GPU_clock_speed)}}<span class="chip-unit"> MHz</span></span>
                    <span class="small-bullet key">Core Clock</span>
                </div>
                <!-- Ram Capacity -->
                <div style="min-width: 64px !important" v-if="this.currentItem.chosen==true && this.currentItem.type == 'graphics'" class="best-for" >
                    <span style=" display:block; " class="small-bullet value">{{parseInt(this.currentItem.specs.graphics_ram_capacity)}}<span class="chip-unit"> GB</span></span>
                    <span class="small-bullet key">RAM</span>
                </div>
                <!-- Bandwidth -->
                <div style="min-width: 64px !important" v-if="this.currentItem.chosen==true && this.currentItem.type == 'graphics'" class="best-for" >
                    <span style=" display:block;" class="small-bullet value">{{parseInt(this.currentItem.specs.memory_bus_width)}}<span class="chip-unit"> bit</span></span>
                    <span class="small-bullet key">Bus</span>
                </div>
                <!-- Memory Clock -->
                <div style="min-width: 85px !important" v-if="this.currentItem.chosen==true && this.currentItem.type == 'graphics' && hasDisplayValue(this.currentItem.specs.memory_clock_speed)" class="best-for" >
                    <span style=" display:block; min-width: 80px;" class="small-bullet value">{{parseInt(this.currentItem.specs.memory_clock_speed)}}<span class="chip-unit"> MHz</span></span>
                    <span class="small-bullet key">Memory Clock</span>
                </div>
                <!-- PCI_E_x16 SLOT -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'graphics' || this.currentItem.type == 'gpu')" class="best-for" >
                    <div  v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'pci_e_x16'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('motherboard', 'pci_e_x16', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'pci_e_x16', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"
                    style=" display:block;"
                    class="small-bullet value">
                        <span v-if="allMenuOptions.graphics.item.contents && allMenuOptions.graphics.item.contents.length >0">{{allMenuOptions.graphics.item.contents.length}}</span><span v-else>0</span>
                        <span v-if="allMenuOptions.motherboard.item.contents">/{{allMenuOptions.motherboard.item.contents.compat.pci_e_x16}}</span>
                    </span>
                    <span v-if="compatIssueMsg([['motherboard','pci_e_x16']])" class="icon compat-issue-badge" :class="compatIssueIcon([['motherboard','pci_e_x16']])" v-gixtip="compatIssueMsg([['motherboard','pci_e_x16']])"></span>
                    <span class="small-bullet key">PCI-E (x16) Slots</span>
                </div>
        <!-- PSU -->
                <!-- POWER -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'psu')" class="best-for" >
                    <div  v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'general', option: 'power'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('general', 'power', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('general', 'power', allMenuOptions, this.currentItem, getCompatTable) == true
                        }"
                        style=" display:block;"
                        class="small-bullet value">
                        <span v-if="allMenuOptions">{{this.getBuildTDP}}/</span><span v-else>0</span>
                        <span v-if="allMenuOptions">{{parseInt(this.currentItem.specs.wattage)}}<span class="chip-unit"> W</span></span>
                    </span>
                    <span v-if="compatIssueMsg([['general','power']])" class="icon compat-issue-badge" :class="compatIssueIcon([['general','power']])" v-gixtip="compatIssueMsg([['general','power']])"></span>
                    <span class="small-bullet key">Power</span>
                </div>
                <!-- FORM FACTOR -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'psu')" class="best-for" >
                    <div v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'form_factor'})}}</div>
                    <div v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'case', option: 'form_factor'})}}</div>
                    <span :class="{
                        incompatible:
                            checkCompatTable('motherboard',         'form_factor', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('case',                'form_factor', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:
                            checkCompatTable('motherboard',         'form_factor', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('case',                'form_factor', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"
                    style=" display:block;"
                    class="small-bullet value">
                        <span v-if="allMenuOptions">{{this.currentItem.compat.form_factor}}</span>
                    </span>
                    <span v-if="compatIssueMsg([['motherboard','form_factor'],['case','form_factor']])" class="icon compat-issue-badge" :class="compatIssueIcon([['motherboard','form_factor'],['case','form_factor']])" v-gixtip="compatIssueMsg([['motherboard','form_factor'],['case','form_factor']])"></span>
                    <span class="small-bullet key">Form Factor</span>
                </div>
        <!-- CASE -->
                <!-- FORM FACTOR -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'case')" class="best-for" >
                    <div v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'form_factor'})}}</div>
                    <div v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'psu', option: 'form_factor'})}}</div>
                    <span :class="{
                        incompatible:
                            checkCompatTable('motherboard',         'form_factor', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('psu',                 'form_factor', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:
                            checkCompatTable('motherboard',         'form_factor', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('psu',                 'form_factor', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"
                    style=" display:block;"
                    class="small-bullet value">
                        <span v-if="allMenuOptions">{{this.currentItem.compat.form_factor}}</span>
                    </span>
                    <span v-if="compatIssueMsg([['motherboard','form_factor'],['psu','form_factor']])" class="icon compat-issue-badge" :class="compatIssueIcon([['motherboard','form_factor'],['psu','form_factor']])" v-gixtip="compatIssueMsg([['motherboard','form_factor'],['psu','form_factor']])"></span>
                    <span class="small-bullet key">Form Factor</span>
                </div>
            </div>
            </div>
            <!-- BUTTONS -->
            <div v-if="currentItem !== ''" class="buttons slider-panel-card slider-actions-panel">
                <div v-if="showPricePanel" class="price slider-price-block">
                    <div class="slider-price-header">
                        <span class="slider-price-label">{{ pricePanelLabel }}</span>
                        <span v-if="hasAmazonLink" class="slider-price-source">Amazon</span>
                    </div>
                    <template v-if="showExactPrice">
                        <div class="slider-price-lockup">
                            <h4 class="dollar-sign">$</h4>
                            <h2 @click="startAnimate()" class="price-tag">
                                <animate-number
                                ref="animatedNumber"
                                :from="priceFrom"
                                mode="auto"
                                :to="priceTo"
                                duration="700"
                                :formatter="formatter"
                            ></animate-number></h2>
                            <span class="price-cents">{{ displayedCents }}</span>
                        </div>
                        <span class="slider-price-meta">{{ priceMeta }}</span>
                    </template>
                    <template v-else>
                        <div class="slider-typical-range">
                            <strong>{{ typicalPriceRange }}</strong>
                        </div>
                        <span class="slider-price-meta">{{ priceMeta }}</span>
                    </template>
                </div>
                <button v-if="!ifAdded(this.currentItem)" @click="addToBuild(currentItem), addToMenu(currentItem), getPrice(), trackProduct('select', currentItem)" class="gc-button btn slider-action-button slider-action-button--primary slider-compact-cta">
                    ADD TO BUILD<span class="icon icon-check" ></span>
                </button>
                <!-- IF RAM || STORAGE || GPU -->
                <div v-if="ifAdded(this.currentItem) && isStackableType" class="slider-action-stack" >
                    <div class="slider-action-row slider-quantity-row">
                        <button v-if="ifAdded(this.currentItem)"  @click="rmFromBuild({item: currentItem, id: currentItem.id}), rmFromMenu({item: currentItem, id: currentItem.id}), getPrice(), trackProduct('remove', currentItem)" class="gc-button btn slider-icon-button slider-icon-button--danger slider-quantity-step slider-remove-one" :aria-label="ifAdded(currentItem) > 1 ? 'Decrease quantity' : 'Remove from build'">
                            <span class="icon" :class="ifAdded(currentItem) > 1 ? 'icon-minus' : 'icon-circle-with-cross'"></span>
                            <span class="slider-remove-label">{{ ifAdded(currentItem) > 1 ? 'Decrease' : 'Remove' }}</span>
                        </button>
                        <div v-if="ifAdded(this.currentItem)" :class="{'checked':ifAdded(currentItem)}" class="gc-button btn slider-action-button slider-action-button--success slider-added-state" role="status" aria-live="polite">
                            Added <span class="slider-count-pill">{{ifAdded(currentItem)}}</span><span class="icon icon-check"></span>
                        </div>
                        <!-- ADD + -->
                        <button v-if="ifAdded(this.currentItem) && hasEmptySlots(this.currentItem, getBuild) == true" @click="addToBuild(currentItem), addToMenu(currentItem), getPrice(), trackProduct('add', currentItem)" class="gc-button btn slider-icon-button slider-quantity-step" aria-label="Add one more to build">
                            <span class="icon icon-plus"></span>
                        </button>
                        <button v-if="ifAdded(this.currentItem) && hasEmptySlots(this.currentItem, getBuild) == false" class="gc-button disabled btn slider-icon-button is-disabled slider-quantity-step" aria-label="No empty slots available">
                            <span class="icon icon-plus"></span>
                        </button>
                    </div>
                </div>
                <!-- ELSE -->
                <div v-else-if="ifAdded(this.currentItem)" class="slider-single-action">
                    <div class="slider-action-row slider-quantity-row slider-single-selected-row">
                        <button @click="rmFromBuild({item: currentItem, id: undefined}), rmFromMenu({item: currentItem, id: undefined}), getPrice(), trackProduct('remove', currentItem)" class="gc-button btn slider-icon-button slider-icon-button--danger slider-quantity-step slider-remove-one" aria-label="Remove from build">
                            <span class="icon icon-circle-with-cross"></span>
                            <span class="slider-remove-label">Remove</span>
                        </button>
                        <div :class="{'checked':ifAdded(currentItem)}" class="gc-button btn slider-action-button slider-action-button--success slider-added-state" role="status" aria-live="polite">
                            Added <span class="icon icon-check"></span>
                        </div>
                    </div>
                </div>
                <a
                    v-if="hasAmazonLink"
                    :id="'amzn-button-' + ((currentItem && currentItem.asin) ? currentItem.asin : '')"
                    :href="amzn_link(this.currentItem)"
                    class="gc-button btn slider-amazon-button slider-compact-cta"
                    target="_blank"
                    rel="nofollow sponsored noopener"
                    aria-label="View on Amazon (opens in a new tab)"
                    @click="trackAmazonClick(currentItem)"
                >
                    <span>View on Amazon</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import axios                         from 'axios'
import { Carousel3d, Slide }    from 'vue-carousel-3d'
import { mapActions }           from 'vuex'
import { mapGetters }           from 'vuex'
import { EventBus }             from '../../eventBus'
import VueSpeedometer           from "vue-speedometer"
import store                    from '../../store'
import { amazonProductUrl, apiDomain, SHOW_PRICES }  from '../../config'
import { functions }            from "../../functions.js"
import gixtip                    from "../../directives/tooltip"
import { getBuildContents as getBuildSlotContents } from '../../partOrder'
import analytics                from '../../services/analytics'
export default {
    name: "Slider",
    components: {
        Carousel3d,
        Slide,
        VueSpeedometer,
    },
    directives: {
        gixtip,
    },
    props: ['items'],
    watch: {
        currentItem: function(newVal) { // watch it
            this.applyPriceState(newVal)
            this.loadEditorialOverview(newVal)
        },
        items:  function(){
            console.log("WATCH ITEMS")
            this.$nextTick(() => {
                this.loadSlides()
                this.syncSelectionFromRoute()
            })
        },
        itemsLength: function(){
            this.$nextTick(() => {
                this.loadSlides()
                this.syncSelectionFromRoute()
                this.refreshSlider()
            })
        },
        computedCurrentIndex: function(newIndex){
            this.autoChoose(newIndex)
        },
        '$route.query.id': function(){
            this.syncSelectionFromRoute()
        }
    },
    data() {
        return {
            priceFrom: 0,
            sliderRefresh: 0,
            firstLoad: true,
            priceTo: 0,
            perf: 0,
            url_id: this.$route.query.id || undefined,
            isMounted: false,
            enlargeClicked: false,
            currentItem: '',
            addImg: {
                sample: require('../../assets/img/add-icon.png')
            },
            currentIndex: "not assigned",
            menuItem: null,
            slides: null,
            syncingFromRoute: false,
            autoChooseTimer: null,
            editorialOverview: '',
            editorialOverviewCache: {},
            editorialOverviewRequest: 0,
            editorialOverviewLoading: false,
            editorialOverviewExpanded: false,
            parentComponent: 'not yet assigned',
            index: Number(),
            viewportWidth: 0,
            welcomedList: {
                'Generation':           'Generation',
                'Integrated_Graphics':  'Int. Graphics',
                'Capacity':             'Capacity',
                'Cache_Memory':         'Cache Memory',
                'RAM_Type':             'RAM_Type',
                'RAM_Speed':            'RAM_Speed',
                'Number_of_Sticks':     'Sticks',
                'Disk_Type':            'Type',
                'size':                 'Size',
                'data_transfer_rate':   'Speed',
                'memory_clock_speed':   'Memory Clock',
                'graphics_interface':   'Interface',
                'connections':          'Connectors',
                'VR':                   'VR Support',
                'WiFi':                 "WiFi",
                'M_2_Slot':             'M.2_Slot',
                'm_2':                  'M.2',
                'wattage':              'Wattage',
                'energy_rating':        'Energy Rating',
                'tempered_glass':       'Tempered Glass',
                'color':                'Colors',
                'tdp':                  'TDP',
            },
        }
    },
    computed: {
        ...mapGetters([
            'allMenuOptions',
            'getCompatTable',
            'getBuildTDP',
            'getBuild'
        ]),
        itemsLength(){
            if(this.items){
                return this.items.length
            }
            return 0
        },
        currentPrice(){
            return this.getNumericPrice(this.currentItem && this.currentItem.amzn_price)
        },
        showPrices(){
            return SHOW_PRICES
        },
        showPricePanel(){
            return this.hasValidPrice
        },
        hasValidPrice(){
            return this.currentPrice !== null && this.currentPrice > 0
        },
        showExactPrice(){
            return this.showPrices && this.hasValidPrice
        },
        pricePanelLabel(){
            return this.showExactPrice ? 'Current price' : 'Estimated price'
        },
        typicalPriceRange(){
            return functions.formatTypicalPriceBand(this.currentPrice)
        },
        priceRecordedDate(){
            return functions.formatPriceRecordedAt(this.currentItem)
        },
        priceMeta(){
            if(this.showExactPrice){
                return (this.priceRecordedDate ? 'Recorded ' + this.priceRecordedDate + ' \u00b7 ' : '')
                    + 'Affiliate price may change.'
            }
            // Always say it is an estimate. The recorded date alone reads like a
            // quote, which the band deliberately is not.
            return this.priceRecordedDate
                ? 'Estimated from the catalog price recorded ' + this.priceRecordedDate + '.'
                : 'Estimated from the latest catalog price.'
        },
        displayedCents(){
            if(!this.hasValidPrice){
                return ''
            }
            return '.' + this.cents(this.currentPrice)
        },
        currentItemTitle(){
            if(!this.currentItem || !this.currentItem.model){
                return ''
            }
            if(this.currentItem.type === 'cpu'){
                return this.currentItem.model
            }
            return [this.currentItem.brand, this.currentItem.model].filter(Boolean).join(' ')
        },
        currentTypeLabel(){
            var typeLabels = {
                cpu: 'Processor',
                motherboard: 'Motherboard',
                ram: 'Memory',
                storage: 'Storage',
                gpu: 'Graphics Card',
                graphics: 'Graphics Card',
                psu: 'Power Supply',
                case: 'Case',
                cooling: 'Cooling'
            }

            if(this.currentItem && typeLabels[this.currentItem.type]){
                return typeLabels[this.currentItem.type]
            }

            return 'Selected Part'
        },
        editorialOverviewCopy(){
            return this.editorialOverview || this.getEditorialSummary(this.currentItem)
        },
        editorialOverviewParagraphs(){
            var copy = this.editorialOverviewCopy
            if(!copy){
                return []
            }
            return String(copy)
                .split(/\n\s*\n/)
                .map((paragraph) => this.parseEditorialParagraph(paragraph))
                .filter((paragraph) => paragraph.text || paragraph.sources.length)
        },
        editorialOverviewCanExpand(){
            return this.editorialOverviewCopy.length > 360 || this.editorialOverviewParagraphs.length > 1
        },
        hasPerformanceGauge(){
            return !!(this.currentItem && (this.currentItem.type == 'cpu' || this.currentItem.type == 'gpu' || this.currentItem.type == 'graphics'))
        },
        isStackableType(){
            return !!(this.currentItem && (this.currentItem.type == 'ram' || this.currentItem.type == 'storage' || this.currentItem.type == 'gpu' || this.currentItem.type == 'graphics'))
        },
        hasAmazonLink(){
            return !!this.amzn_link(this.currentItem)
        },
        // Overall compatibility of the current item against the selected build,
        // aggregated from the same compat table the tiles read. Drives the
        // status line in the "Compatibility snapshot" panel.
        compatSummary(){
            var neutral = { kind: 'neutral', icon: 'icon-info-with-circle', label: 'Compatibility updates as you select more parts.' }
            var table = this.getCompatTable
            var type = this.currentItem && this.currentItem.type
            if(!table || !type || !table[type]){
                return neutral
            }
            var incompatible = 0
            var warning = 0
            var checked = 0
            var withTypes = table[type]
            for(var wt in withTypes){
                for(var opt in withTypes[wt]){
                    var entry = withTypes[wt][opt]
                    if(!entry){ continue }
                    checked++
                    if(entry.compatible === false){ incompatible++ }
                    else if(entry.warning){ warning++ }
                }
            }
            if(checked === 0){
                return neutral
            }
            if(incompatible > 0){
                return { kind: 'incompatible', icon: 'icon-circle-with-cross', label: incompatible === 1 ? 'Not compatible — 1 conflict with your build' : 'Not compatible — ' + incompatible + ' conflicts with your build' }
            }
            if(warning > 0){
                return { kind: 'warning', icon: 'icon-warning', label: warning === 1 ? 'Compatible — 1 warning to review' : 'Compatible — ' + warning + ' warnings to review' }
            }
            return { kind: 'compatible', icon: 'icon-check', label: 'Compatible with your selected build' }
        },
        performanceScore(){
            var normalizedPerf = Number(this.perf)

            if(Number.isNaN(normalizedPerf) || normalizedPerf < 0){
                return 0
            }

            return Math.min(100, Math.round(normalizedPerf))
        },
        performanceScoreToneClass(){
            if(this.performanceScore >= 80){
                return 'slider-score-pill--high'
            }

            if(this.performanceScore >= 55){
                return 'slider-score-pill--mid'
            }

            return 'slider-score-pill--low'
        },
        performanceSummary(){
            if(this.performanceScore >= 80){
                return 'High-headroom fit for demanding builds.'
            }

            if(this.performanceScore >= 55){
                return 'Balanced fit for most enthusiast builds.'
            }

            return 'Value-oriented fit for essential builds.'
        },
        carouselWidth(){
            if(this.viewportWidth <= 420){
                return Math.max(168, Math.min(200, this.viewportWidth - 120))
            }

            if(this.viewportWidth <= 760){
                return 216
            }

            if(this.viewportWidth >= 1360){
                return 240
            }

            if(this.viewportWidth >= 1240){
                return 228
            }

            if(this.viewportWidth >= 1100){
                return 216
            }

            return 216
        },
        carouselHeight(){
            return Math.round(this.carouselWidth * 0.75)
        },
        carouselSpace(){
            if(this.viewportWidth <= 760){
                return 'auto'
            }

            if(this.viewportWidth >= 1360){
                return 280
            }

            if(this.viewportWidth >= 1240){
                return 260
            }

            if(this.viewportWidth >= 1100){
                return 240
            }

            return 'auto'
        },
        carouselInverseScaling(){
            if(this.viewportWidth <= 760){
                return 235
            }

            if(this.viewportWidth >= 1360){
                return 420
            }

            if(this.viewportWidth >= 1240){
                return 390
            }

            if(this.viewportWidth >= 1100){
                return 360
            }

            return 300
        },
        carouselPerspective(){
            if(this.viewportWidth <= 760){
                return 38
            }

            if(this.viewportWidth >= 1360){
                return 32
            }

            if(this.viewportWidth >= 1240){
                return 28
            }

            if(this.viewportWidth >= 1100){
                return 26
            }

            return 35
        },
        carouselKey(){
            return [
                this.sliderRefresh,
                this.carouselWidth,
                this.carouselHeight,
                this.carouselSpace,
                this.carouselInverseScaling,
                this.carouselPerspective,
            ].join('-')
        },
        computedCurrentIndex(){
            while (!this.slides){
                return 0
            }
            var ind = 0
            this.slides.map((slide) => {
                if(slide.isCurrent == true) {
                    return ind = slide.index
                }
            })
            return ind
        },
    },
    methods: {
        ...mapActions([
            'addToBuild',
            'rmFromBuild',
            'rmFromMenu',
            'addToMenu',
            'setStartIndex',
            'getPrice',
            'setItems',
            'isCompatible'
        ]),
        getIdByIndex(index){
            if(this.items && this.items[index]){
                return this.items[index].id
            }
        },
        loadSlides(){
            if(this.$refs.slides && this.slides !== this.$refs.slides){
                this.slides = this.$refs.slides
            }
        },
        syncViewportWidth(){
            if(typeof window !== 'undefined'){
                this.viewportWidth = window.innerWidth
            }
        },
        currentSlide(){
            console.log(this.slides)
            console.log(this.computedCurrentIndex)
        },
        refreshSlider(id){
            this.updateRouteId(id, true)
            this.sliderRefresh++
        },
        updateRouteId(id, replace){
            if(id === undefined || id === null){
                return
            }
            if(this.$route.query.id && String(this.$route.query.id) == String(id) && this.$route.query.view == 'slider'){
                return
            }
            var nextQuery = Object.assign({}, this.$route.query, { view: 'slider', id: id })
            var navigate = replace ? this.$router.replace : this.$router.push
            navigate.call(this.$router, { query: nextQuery }).catch(()=>{})
        },
        removeRedirQuery(){
            if(!this.$route.query.redir){
                return
            }
            var query = Object.assign({}, this.$route.query)
            delete query.redir
            this.$router.replace({ query: query }).catch(()=>{})
        },
        cents:              (num)                                       => functions.cents(num),
        getItemValue:       ({item, field})                             => functions.getItemValue({item, field}),
        checkPartCompat:    ({compatTable, type, asin})                 => functions.checkPartCompat({compatTable, type, asin}),
        checkCompatTable:   (type, option, build, item, compatTable)    => functions.checkCompatTable(type, option, build, item, compatTable),
        // For a list of [withType, option] pairs, returns the first failing
        // check as { kind: 'incompatible' | 'warning' | '', message }.
        // Incompatible takes priority over warning. Drives the spec-chip status
        // icon + tooltip on the compatibility tiles.
        compatIssue(checks){
            var warning = null
            var compatible = false
            for(var i = 0; i < checks.length; i++){
                var type = checks[i][0]
                var option = checks[i][1]
                var res = this.checkCompatTable(type, option, this.allMenuOptions, this.currentItem, this.getCompatTable)
                if(res == false){
                    return { kind: 'incompatible', message: functions.getCompatMessage(type, option, this.allMenuOptions, this.currentItem, this.getCompatTable) }
                }
                if(res == 'warning' && !warning){
                    warning = { kind: 'warning', message: functions.getCompatMessage(type, option, this.allMenuOptions, this.currentItem, this.getCompatTable) }
                }
                if(res === true){ compatible = true }
            }
            if(warning){ return warning }
            if(compatible){ return { kind: 'compatible', message: 'Compatible with your build' } }
            return { kind: '', message: '' }
        },
        compatIssueMsg(checks){
            return this.compatIssue(checks).message
        },
        compatIssueIcon(checks){
            var kind = this.compatIssue(checks).kind
            if(kind == 'incompatible'){ return 'icon-circle-with-cross compat-issue-incompatible' }
            if(kind == 'warning'){ return 'icon-warning compat-issue-warning' }
            if(kind == 'compatible'){ return 'icon-check compat-issue-compatible' }
            return ''
        },
        releaseSource(item){
            if(!item){ return {} }
            return item.general || item.general_info || item
        },
        releaseDateInfo(item){
            var source = this.releaseSource(item)
            var direct = item || {}
            var date = source.release_date || direct.release_date
            return {
                date: this.formatReleaseDate(date),
                precision: source.release_date_precision || direct.release_date_precision,
                confidence: source.release_date_confidence || direct.release_date_confidence,
                sourceName: source.release_date_source_name || direct.release_date_source_name,
                sourceUrl: source.release_date_source_url || direct.release_date_source_url,
                note: source.release_date_note || direct.release_date_note,
                checkedAt: source.release_date_checked_at || direct.release_date_checked_at
            }
        },
        formatReleaseDate(value){
            if(!this.hasDisplayValue(value)){ return '' }
            var text = String(value).trim()
            var d = new Date(text)
            if(!isNaN(d) && /^\d{4}-\d{2}-\d{2}/.test(text)){
                return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
            }
            if(!isNaN(d) && /^\d{4}-\d{2}/.test(text)){
                return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short' })
            }
            return text
        },
        // Split a summary-card spec into number + unit so the unit can be dimmed.
        summaryUnit(key){
            if(key == 'Cache Memory'){ return 'MB' }
            if(key == 'Capacity' || key == 'Max RAM'){ return 'GB' }
            if(key == 'RAM Speed' || key == 'Memory Clock'){ return 'MHz' }
            if(key == 'TDP' || key == 'Wattage'){ return 'W' }
            return ''
        },
        summaryNumber(compat, key){
            return this.summaryUnit(key) ? parseInt(compat) : compat
        },
        formatter: function (num) {
            return parseInt(num)
        },
        getNumericPrice(value){
            return functions.parsePrice(value)
        },
        applyPriceState(item){
            if(!SHOW_PRICES){
                this.priceFrom = 0
                this.priceTo = 0
                this.firstLoad = false
                return
            }
            var nextPrice = this.getNumericPrice(item && item.amzn_price)

            if(nextPrice === null){
                this.priceFrom = 0
                this.priceTo = 0
                this.firstLoad = false
                return
            }

            if(this.firstLoad == true || !this.$refs.animatedNumber){
                this.priceFrom = nextPrice
                this.priceTo = nextPrice
                this.firstLoad = false
                return
            }

            this.priceFrom = this.priceTo
            this.priceTo = nextPrice
            this.updatePrice(this.priceFrom, this.priceTo)
            this.startAnimate()
        },
        amzn_link(item) {
            return amazonProductUrl(item && item.asin)
        },
        trackAmazonClick(item) {
            // Outbound affiliate-click event to GTM (GTM-WKDJVRS). Measurable
            // proxy KPI for paid/organic traffic. Must never block navigation.
            try {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'affiliate_click',
                    affiliate: 'amazon',
                    part_type: item && item.type,
                    asin: item && item.asin,
                    model: item && item.model,
                    price: SHOW_PRICES ? item && item.amzn_price : null,
                });
            } catch (e) { /* analytics must never break the buy link */ }
            // GixCore audience: outbound affiliate click as a first-party event.
            try {
                analytics.trackAmazonClick({
                    targetId: item && item.id,
                    asin: item && item.asin,
                    url: this.amzn_link(item),
                    partType: item && item.type,
                    model: item && item.model,
                    price: SHOW_PRICES ? item && item.amzn_price : null,
                    source: 'slider',
                })
            } catch (e) { /* best-effort */ }
        },
        // Product select/add/remove → first-party audience event (which product).
        trackProduct(action, item) {
            try { analytics.trackProduct(action, item) } catch (e) { /* best-effort */ }
        },
        updatePrice(from, to) {
            this.$refs.animatedNumber.reset(from, to)
        },
        startAnimate: function () {
            this.$refs.animatedNumber.start()
        },
        getMaxMem({cpu, mb}){
            if(cpu && mb){
                if(parseInt(cpu.specs.Max_Memory_Size) <= parseInt(mb.specs.Max_Memory_Size)){
                    return cpu.specs.Max_Memory_Size
                }
                else return mb.specs.Max_Memory_Size
            }
            else if(cpu){
                return cpu.specs.Max_Memory_Size
            }
            else if(mb){
                return mb.specs.Max_Memory_Size
            }
            else return
        },
        getMainImgUrl(imgUrl){
            var imgUrlArray = JSON.parse(imgUrl)
            if(typeof(imgUrlArray[0]) == 'string' && imgUrlArray[0].includes('a href')){
                return imgUrlArray[1]
            }
            console.log('type of img ', typeof(imgUrlArray[0]))
            return imgUrlArray[0]
        },
        getBuildContents(build, type){
            return getBuildSlotContents(build, type)
        },
        normalizedStorageValue(item, field){
            if(!item || !item.compat || item.compat[field] === undefined || item.compat[field] === null){
                return ''
            }
            return String(item.compat[field]).toLowerCase()
        },
        isM2Storage(item){
            if(!item || item.type !== 'storage'){ return false }
            var size = this.normalizedStorageValue(item, 'size')
            var interfaceValue = this.normalizedStorageValue(item, 'compat_interface')
            return size.includes('m.2')
                || size.includes('m2')
                || interfaceValue.includes('m.2')
                || interfaceValue.includes('m2')
                || interfaceValue.includes('nvme')
                || interfaceValue.includes('pci')
        },
        isSataStorage(item){
            return !!(item && item.type == 'storage' && !this.isM2Storage(item))
        },
        countStorageBySlot(items, slotType){
            var total = 0
            if(!items || !items.length){ return total }
            items.forEach((existingItem) => {
                if(slotType == 'm2' && this.isM2Storage(existingItem)){ total++ }
                if(slotType == 'sata' && this.isSataStorage(existingItem)){ total++ }
            })
            return total
        },
        hasEmptySlots(item, build){
            var type = item.type
            // RAM
            var mb
            if(type == 'ram'){
                var sticksTotal = 0
                var limit = 9
                var ram = this.getBuildContents(build, 'ram')
                mb = this.getBuildContents(build, 'motherboard')
                if(ram && ram.length > 0){
                    ram.map((item) => {
                    if(item.compat.number_of_items){
                        var sticks = parseInt(item.compat.number_of_items)
                        sticksTotal += sticks
                    }
                    })
                }
                if(mb && mb.compat.ram_slots){
                limit = parseInt(mb.compat.ram_slots)
                }
                if(sticksTotal >= limit){
                    return false
                }
                else {
                return true
                }
            }
            // STORAGE
            if(type == 'storage'){
                var occupiedSata = 0
                var occupiedM2 = 0
                var maxSata =  9
                var maxM2 =  9
                mb = this.getBuildContents(build, 'motherboard')
                var storage = this.getBuildContents(build, 'storage')
                // Setting max ports
                if(mb && mb !==null){
                if(parseInt(mb.compat.M_2_Slot) >0){
                    maxM2 = parseInt(mb.compat.M_2_Slot)
                }
                if(parseInt(mb.compat.sata_slots) >0){
                    maxSata = parseInt(mb.compat.sata_slots)
                }
                }
                occupiedSata = this.countStorageBySlot(storage, 'sata')
                occupiedM2 = this.countStorageBySlot(storage, 'm2')
                // If no more free sata slots
                if(this.isSataStorage(item)){
                if(occupiedSata >= maxSata){
                    return false
                }
                }
                // If no more free m.2 slots
                if(this.isM2Storage(item)){
                if(occupiedM2 >= maxM2){
                    return false
                }
                }
                return true
            }
            //GPU
            if(type == 'gpu' || type == 'graphics'){
                var slotsTotal = 0
                var max =  9
                var gpu = this.getBuildContents(build, 'graphics')
                mb = this.getBuildContents(build, 'motherboard')
                if(mb && mb.compat.pci_e_x16){
                max = parseInt(mb.compat.pci_e_x16)
                }
                if(gpu && gpu.length > 0){
                gpu.map(() => {
                    slotsTotal += 1
                })
                }
                if(slotsTotal >= max){
                return false
                }
                else {
                return true
                }
            }
            else {
                return true
            }
            },
        getCompatibility({item, withType, option}){
            return store.dispatch('isCompatible', {item: item, withType: withType, option: option})
            .then((res) => {return res})
        },
        refreshPrice(){
            console.log(this.$refs['animatedNumber'])
        },
        getStartIndex(){
            var routeIndex = this.findItemIndexById(this.$route.query.id)
            if(routeIndex >= 0){
                return routeIndex
            }
            return this.computedCurrentIndex
        },
        findItemIndexById(id){
            if(!this.items || id === undefined || id === null){
                return -1
            }
            var selectedId = String(id)
            for(var index = 0; index < this.items.length; index++){
                var item = this.items[index]
                if(item && item.id !== undefined && String(item.id) == selectedId){
                    return index
                }
                if(Array.isArray(item)){
                    for(var i = 0; i < item.length; i++){
                        if(item[i] && item[i].id !== undefined && String(item[i].id) == selectedId){
                            return index
                        }
                    }
                }
            }
            return -1
        },
        selectItemAtIndex(index, syncCarousel){
            if(!this.items || index === undefined || index === null || index < 0 || index >= this.items.length){
                return
            }
            for (var i = 0; i < this.items.length; i++){
                this.items[i].chosen = false
            }
            if(this.currentItem !== this.items[index] || this.currentItem.chosen !== true){
                this.items[index].chosen = true
                this.setStartIndex(index)
                this.currentItem = this.items[index]
            }
            if(syncCarousel && this.$refs.slider && this.$refs.slider.goSlide && this.computedCurrentIndex !== index){
                this.$refs.slider.goSlide(index)
            }
        },
        syncSelectionFromRoute(){
            if(!this.items || this.items.length === 0){
                return
            }
            var routeId = this.$route.query.id
            var routeIndex = this.findItemIndexById(routeId)
            var nextIndex = routeIndex >= 0 ? routeIndex : 0
            this.url_id = routeId
            this.syncingFromRoute = true
            this.$nextTick(() => {
                this.selectItemAtIndex(nextIndex, routeIndex >= 0)
                if(routeIndex < 0 && this.items[nextIndex]){
                    this.updateRouteId(this.items[nextIndex].id, true)
                }
                this.removeRedirQuery()
                setTimeout(() => {
                    this.syncingFromRoute = false
                }, 0)
            })
        },
        autoChoose(index){
            if(this.syncingFromRoute){
                return
            }
            if(this.autoChooseTimer){
                clearTimeout(this.autoChooseTimer)
            }
            this.autoChooseTimer = setTimeout(() => {
                this.autoChooseTimer = null
                if(this.syncingFromRoute){
                    return
                }
                if(this.items && index !== undefined && index !== null && index >= 0 && index < this.items.length){
                    this.selectItemAtIndex(index, false)
                    this.updateRouteId(this.getIdByIndex(index), true)
                    this.removeRedirQuery()
                    console.log("autochoose applied, item chosen: ", this.items[index])
                }
            }, 40)
        },
        getListBullets(item){
            var specsList = {}
            for (var spec in item.specs){
                if(this.hasDisplayValue(item.specs[spec]) && Object.keys(this.welcomedList).includes(spec)){
                specsList[this.welcomedList[spec].split('_').join(' ')] = item.specs[spec]
                }
            }
            for (var compat in item.compat){
                if(this.hasDisplayValue(item.compat[compat]) && Object.keys(this.welcomedList).includes(compat)){
                specsList[this.welcomedList[compat].split('_').join(' ')] = item.compat[compat]
                }
            }
            var release = this.releaseDateInfo(item)
            if(release.date){
                specsList['Released'] = release.date
            }
            return specsList
        },
        getEditorialSummary(item){
            if(!item){
                return ''
            }

            var content = item.content || {}
            var candidates = [
                content.seoSummary,
                content.seo_summary,
                item.seoSummary,
                item.seo_summary
            ]

            for(var i = 0; i < candidates.length; i++){
                if(this.hasDisplayValue(candidates[i])){
                    return String(candidates[i]).replace(/\s+/g, ' ').trim()
                }
            }

            return ''
        },
        async loadEditorialOverview(item){
            var request = ++this.editorialOverviewRequest
            this.editorialOverview = ''
            this.editorialOverviewLoading = false
            this.editorialOverviewExpanded = false

            if(!item){
                return
            }

            var inlineContent = item.content || {}
            var inlineOverview = inlineContent.originalDescription || inlineContent.original_description
            if(this.hasDisplayValue(inlineOverview)){
                this.editorialOverview = String(inlineOverview).trim()
                return
            }

            var type = item.type === 'gpu' ? 'graphics' : item.type
            var slug = item.slug
            if(!type || !slug){
                return
            }

            var cacheKey = type + ':' + slug
            if(Object.prototype.hasOwnProperty.call(this.editorialOverviewCache, cacheKey)){
                this.editorialOverview = this.editorialOverviewCache[cacheKey]
                return
            }

            this.editorialOverviewLoading = true
            try {
                var response = await axios.get(
                    apiDomain + 'catalog/' + encodeURIComponent(type) + '/' + encodeURIComponent(slug)
                )
                var content = response && response.data && response.data.content
                    ? response.data.content
                    : {}
                var overview = content.originalDescription || content.original_description || ''
                var normalized = this.hasDisplayValue(overview) ? String(overview).trim() : ''
                this.$set(this.editorialOverviewCache, cacheKey, normalized)
                if(request === this.editorialOverviewRequest){
                    this.editorialOverview = normalized
                }
            }
            catch(error){
                this.$set(this.editorialOverviewCache, cacheKey, '')
            }
            finally {
                if(request === this.editorialOverviewRequest){
                    this.editorialOverviewLoading = false
                }
            }
        },
        parseEditorialParagraph(rawParagraph){
            var sources = []
            var markdownLink = /\[([^\]]+)]\((https?:\/\/[^\s)]+)\)/gi
            var text = String(rawParagraph || '')
                .replace(markdownLink, (match, rawLabel, url) => {
                    if(!sources.some((source) => source.url === url)){
                        sources.push({ label: this.editorialSourceLabel(rawLabel, url), url: url })
                    }
                    return ''
                })
                .replace(/\(\s*\)/g, '')
                .replace(/\s+([,.;:!?])/g, '$1')
                .replace(/[ \t]{2,}/g, ' ')
                .trim()

            return { text: text, sources: sources }
        },
        editorialSourceLabel(rawLabel, url){
            var hostname = ''
            try {
                hostname = new URL(url).hostname.replace(/^www\./i, '').toLowerCase()
            }
            catch(error){
                hostname = ''
            }
            var brandNames = {
                'asrock.com': 'ASRock',
                'pcworld.com': 'PCWorld'
            }
            return brandNames[hostname] || String(rawLabel || '').replace(/^www\./i, '').trim() || hostname
        },
        hasDisplayValue(value){
            if(value === null || value === undefined){
                return false
            }

            if(typeof value === 'number'){
                return value === value
            }

            if(typeof value === 'string'){
                var trimmed = value.trim()
                var normalized = trimmed.toLowerCase()

                return trimmed !== ''
                    && normalized !== 'n/a'
                    && normalized !== 'na'
                    && normalized !== 'undefined'
                    && normalized !== 'null'
                    && normalized !== 'nan'
            }

            if(Array.isArray(value)){
                return value.length > 0
            }

            return true
        },
        unset(){
            this.menuItem = null
        },
        enlarge(item){
            EventBus.$emit('enlarge', item)
        },
        ifAdded(item){
            var type = ''
            if(item && item.type){
                if(item.type == "gpu"){
                    type = 'graphics'
                }
                else {
                    type = item.type
                }
            }
            if(this.getMenuOptions() && this.getMenuOptions()[type] && this.getMenuOptions()[type].item.contents && (type == 'storage' || type == 'ram' || type == 'graphics' || type == 'gpu')){
                if(typeof(this.getMenuOptions()[type].item.contents == 'object') && this.getMenuOptions()[type].item.contents.length > 0){
                    var response = false
                    var seen = []
                for (var i = 0; i < this.getMenuOptions()[type].item.contents.length; i++){
                    if (this.getMenuOptions()[type].item.contents[i].id == item.id){
                        seen.push(item.id)
                    }
                    else{
                        response = false
                    }
                }
                if(seen.length > 0){
                    return seen.length
                }
                return response
                }
            }
            else if(this.getMenuOptions() && this.getMenuOptions()[type] && this.getMenuOptions()[type].item.contents){
                if(item.id == this.getMenuOptions()[type].item.contents.id){
                return true
                }
            }
            return false
        },
        getMenuOptions(){
            return this.allMenuOptions
        },
        getMainImg(imgUrl){
            return imgUrl
        },
    },
    updated(){
        this.loadSlides()
        //Updating slides variable
        if(this.currentItem.performance && this.currentItem.performance >1){
            this.perf = this.currentItem.performance
        }
    },
    beforeDestroy(){
        if(this.autoChooseTimer){
            clearTimeout(this.autoChooseTimer)
        }
        if(typeof window !== 'undefined'){
            window.removeEventListener('resize', this.syncViewportWidth)
        }
    },
    beforeMount(){
        EventBus.$on('goSlide', (index) => {
            console.log('received start slide index ', index)
            this.index = index
        })
    },
    mounted() {
        this.syncViewportWidth()
        if(typeof window !== 'undefined'){
            window.addEventListener('resize', this.syncViewportWidth)
        }
        document.addEventListener("keydown", (event) => {
            if(event.keyCode == 39 && this.$refs.slider){
                this.$refs.slider.goNext()
            }
            else if (event.keyCode == 37 && this.$refs.slider){
                this.$refs.slider.goPrev()
            }
        });
        EventBus.$on('added', (item) => {
            this.menuItem = item
        });
        EventBus.$on('unset', () => {
            console.log('received unset')
            this.unset();
        });
        this.isMounted = true;
        this.$nextTick(() => {
            this.loadSlides()
            if(!this.$route.query.id && this.items && this.items[0]){
                this.updateRouteId(this.items[0].id, true)
            }
            this.syncSelectionFromRoute()
        })
    },
}
</script>
<style>
@import '../../assets/css/slider.css';
.amzn-button {
    transition: 0.2s !important;
    position: relative;
}
.big-title::-webkit-scrollbar {
  display: none;
}
.big-title {
    color: #CFD2DA;
    display: block;
    white-space: normal;
    overflow: visible;
    letter-spacing: 0;
    line-height: 1.12;
    margin-bottom: 0px;
    width: 100%;
}
.big-title::-webkit-scrollbar{
    display: none !important;
}
.price-cents {
    color: #e4d836;
    vertical-align: top;
    margin-left: 2px;
    font-size: 20px;
    font-weight: 600;
}
.price-fallback {
    display: inline-flex;
    flex-direction: column;
    gap: 3px;
    text-align: left;
}
.price-fallback-copy {
    color: #cfd2da;
    font-size: 19px;
    font-weight: 500;
    line-height: 1.2;
}
.price-fallback-note {
    color: #9198aa;
    font-size: 12px;
    line-height: 1.35;
}
.price-fallback-button {
    border-color: rgba(25, 151, 198, 0.85) !important;
}
.amzn-button a {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    min-height: 42px;
    padding: 0 12px;
    color: inherit;
    position: static;
    text-decoration: none;
}
.slider-amazon-copy {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    min-height: 42px;
    padding: 0 12px;
}
.slider-bullets::-webkit-scrollbar {
    display:block !important;
    width: 8px;
}
.slider-bullets::-webkit-scrollbar-track {
    border-radius: 999px;
    background: rgba(18, 22, 31, 0.62);
    box-shadow: inset 0 0 0 1px rgba(74, 82, 103, 0.32);
}
.slider-bullets::-webkit-scrollbar-thumb {
    border: 2px solid rgba(18, 22, 31, 0.62);
    border-radius: 999px;
    background: rgba(25, 151, 198, 0.42);
}
.slider-bullets::-webkit-scrollbar-thumb:hover {
    background: rgba(34, 187, 236, 0.62);
}
.slider-bullets::-webkit-scrollbar-corner {
    background: transparent;
}
.amzn-button:hover a {
    color: white;
}
.amzn-button:hover{
    background-color: #1997c6 !important;
    transition: 0.2s !important;
}
.amzn-button:hover span{
    color: #cfd2da !important;
    transition: 0.2s !important;
}
.infographics {
    justify-content: center;
    min-width: 0 !important;
}
.warn {
    color: #E1d420 !important;
}
/* Compatibility status: a small icon with a tooltip (native title) in the tile
   corner — red ✖ for incompatible, yellow ⚠ for warning — instead of recoloring
   the value text. The performance panel clips overflow, so a CSS pop-up tooltip
   would be cut off; the native title escapes it and handles multi-line messages. */
.slider-performance-panel .best-for {
    position: relative;
}
.compat-issue-badge {
    position: absolute;
    top: 6px;
    right: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
    opacity: 0.85;
    transition: opacity 0.15s ease;
}
.slider-performance-panel .best-for:hover .compat-issue-badge,
.compat-issue-badge:hover {
    opacity: 1;
}
.compat-issue-badge.compat-issue-incompatible {
    color: #e64759;
    text-shadow: 0 0 10px rgba(230, 71, 89, 0.45);
}
.compat-issue-badge.compat-issue-warning {
    color: #e4d836;
    text-shadow: 0 0 10px rgba(228, 216, 54, 0.45);
}
.compat-issue-badge.compat-issue-compatible {
    color: #00bc8c;
    text-shadow: 0 0 10px rgba(0, 188, 140, 0.4);
}
/* Stress incompatible / warning / compatible tiles with a faint tinted
   background + border. :has() picks the tile by which badge it contains. */
.slider-performance-panel .best-for:has(.compat-issue-incompatible) {
    border-color: rgba(230, 71, 89, 0.42);
    background: rgba(230, 71, 89, 0.08);
}
.slider-performance-panel .best-for:has(.compat-issue-warning) {
    border-color: rgba(228, 216, 54, 0.4);
    background: rgba(228, 216, 54, 0.07);
}
.slider-performance-panel .best-for:has(.compat-issue-compatible) {
    border-color: rgba(0, 188, 140, 0.36);
    background: rgba(0, 188, 140, 0.07);
}
/* Compatibility-snapshot status line — colored by overall result. */
.slider-compat-brief--neutral {
    border-color: rgba(25, 151, 198, 0.32) !important;
    background: rgba(25, 151, 198, 0.07) !important;
    color: #a9c3cb;
}
.slider-compat-brief--neutral .icon {
    color: #1997c6;
}
.slider-compat-brief--compatible {
    border-color: rgba(0, 188, 140, 0.32) !important;
    background: rgba(0, 188, 140, 0.08) !important;
    color: #bfe7da;
}
.slider-compat-brief--compatible .icon {
    color: #00bc8c;
}
.slider-compat-brief--warning {
    border-color: rgba(228, 216, 54, 0.42) !important;
    background: rgba(228, 216, 54, 0.08) !important;
    color: #ddd6a6;
}
.slider-compat-brief--warning .icon {
    color: #e4d836;
}
.slider-compat-brief--incompatible {
    border-color: rgba(230, 71, 89, 0.45) !important;
    background: rgba(230, 71, 89, 0.1) !important;
    color: #e7b9bf;
}
.slider-compat-brief--incompatible .icon {
    color: #e64759;
}
/* Main (center) product image rests at 0.95, lifts to full on hover. */
.slider-shell .ischosen .slider-product-image {
    opacity: 0.95;
    transition: opacity 0.2s ease;
}
.slider-shell .ischosen:hover .slider-product-image {
    opacity: 1;
}
/* Units (MHz, GB, W, …) sit slightly dimmer than the number. */
.chip-unit {
    opacity: 0.9;
}
</style>
